import { render, staticRenderFns } from "./factura.vue?vue&type=template&id=ca45387a&"
import script from "./factura.vue?vue&type=script&lang=js&"
export * from "./factura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports